import { axiosInstance } from "./api_instance";

export default async function fetchCars() {

    try {
        const response = await axiosInstance.get(`/cars-left`)
        return response

    } catch (error) {
        return error
    }
} 
